<template>
  <MainCard
    :beta="true"
    title="Modelos"
    sb="Saiba Mais"
    link="https://crmrubeus.zendesk.com/hc/pt-br/articles/32261882979597-Modelos-de-Inteligência-Artificial-no-AI-Studio"
    subtitle="Modelos de IA são representações simplificadas do pensamento humano,  capacitando computadores a entender, aprender e agir inteligentemente  com base em dados e algoritmos."
  >
    <v-sheet class="pa-4 w-100">
      <NavigationCard
        :items="CardData"
        md="6"
        lg="5"
        xlg="5"
        titlecolor="#505353"
        titlefontfamily="Roboto"
        titlefontsize="16px"
        titlefontstyle="normal"
        titlefontweight="500"
        titlelineheight="23.4px"
        typecolor=""
        typefontfamily=""
        typefontsize=""
        typefontstyle=""
        typefontweight=""
        typelineheight=""
        desccolor="#505353"
        descfontfamily="Roboto"
        descfontsize="14px"
        descfontstyle="normal"
        descfontweight="400"
        desclineheight="20px"
        cardWidth="426px"
        cardHeight="168px"
  
        actionActive="1"
        :showAccessAction="true"
        :showToggleAction="false"
        @access="handleAccess"
        @toggle="handleToggle"
      ></NavigationCard>
    </v-sheet>
  </MainCard>
</template>

<script>
import MainCard from "@/ai_studio/components/layout/MainCard.vue";
import NavigationCard from "@/ai_studio/components/common/NavigationCard.vue";

export default {
  name: "ConfigurationView",
  data() {
    return {
      CardData: this.$route.meta.models,
    };
  },
  components: {
    MainCard,
    NavigationCard,
  },

  methods: {
    handleAccess(item) {
      if (item.id === 1) {
        this.$router.push('/configuration');
      } else if (item.id === 2) {
        this.$router.push('/model-catchment');
      }
    },

    handleToggle(item) {
      console.log('Alternando status (toggle) para:', item.name);
    }
  }
};
</script>